import React from "react";
import {
  makeStyles,
  Typography,
  Badge,
  withStyles,
  ThemeProvider,
} from "@material-ui/core";
import ACIcon from "../ACIcon";
import { default as ACTheme } from "../../themes";

const useStyles = makeStyles((theme) => ({
  mainConatiner: {
    display: "flex",
    flexDirection: "row",
    flexShrink: 0,
  },
  shrinkControlContainer: {
    flexShrink: 0,
  },
  button: {
    border: "none",
    display: "flex",
    outline: "none",
    backgroundColor: "transparent",
    padding: 0,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:disabled": {
      cursor: "default",
    },
  },
  commentsTextLarge: {
    marginTop: 3,
    color: theme.palette.info.dark,
  },
  commentsTexMobile: {
    color: theme.palette.info.dark,
    fontSize: "0.7rem",
  },
  badge: {
    fontSize: 10,
  },
}));

const StyledBadge = withStyles(() => ({
  badge: {
    height: 14,
    minWidth: 14,
    padding: 0,
    borderRadius: "50%",
    right: 22,
    top: 4,
    fontSize: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 2,
  },
}))(Badge);

const StyledBadgeLG = withStyles(() => ({
  badge: {
    height: 14,
    minWidth: 14,
    padding: 0,
    borderRadius: "50%",
    right: 24.5,
    top: 6,
    fontSize: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 2,
  },
}))(Badge);

const StyledBadgeXS = withStyles(() => ({
  badge: {
    height: 11,
    minWidth: 11,
    padding: 0,
    borderRadius: "50%",
    right: 17.5,
    top: 2,
    fontSize: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 1,
  },
}))(Badge);

export default function CommentsButton(props) {
  return (
    <ThemeProvider theme={ACTheme}>
      <CommentsButtonContent {...props} />
    </ThemeProvider>
  );
}

function CommentsButtonContent(props) {
  const classes = useStyles();
  const {
    numComments,
    onClick,
    filled,
    badge,
    disabled,
    badgeContent,
    iconSize,
  } = props;

  function sizeSelector() {
    if (iconSize === "xs") {
      return 15;
    }
    if (iconSize === "sm") {
      return 19;
    }
    if (iconSize === "lg") {
      return 24;
    }
    return 19;
  }

  function renderIcon() {
    if (filled) {
      return "comment";
    }
    return "comment-outlined";
  }

  function renderContent() {
    if (
      badgeContent === null ||
      badgeContent === undefined ||
      isNaN(badgeContent)
    ) {
      return <span>&#9679;</span>;
    }
    return badgeContent;
  }

  const unsetNumber =
    numComments === null || (numComments === undefined) | isNaN(numComments);

  function renderComments() {
    if (unsetNumber && iconSize === "xs") {
      return (
        <Typography variant="caption" className={classes.commentsTexMobile}>
          0 Comments
        </Typography>
      );
    }
    if (unsetNumber) {
      return (
        <Typography variant="body1" className={classes.commentsTextLarge}>
          0 Comments
        </Typography>
      );
    }
    if (!unsetNumber && iconSize === "xs") {
      return (
        <Typography variant="caption" className={classes.commentsTexMobile}>
          {`${numComments} Comments`}
        </Typography>
      );
    }
    if (!unsetNumber) {
      return (
        <Typography variant="body1" className={classes.commentsTextLarge}>
          {`${numComments} Comments`}
        </Typography>
      );
    }
    return null;
  }

  function renderBadge() {
    if (badge || badgeContent) {
      return false;
    }
    return true;
  }

  function renderBadgeStyle() {
    if (iconSize === "lg") {
      return (
        <StyledBadgeLG
          badgeContent={renderContent()}
          color="error"
          invisible={renderBadge()}
        >
          <ACIcon
            iconname={renderIcon()}
            style={{
              color: "#162F4B",
              fontSize: sizeSelector(),
              marginRight: "3.5px",
            }}
          />
        </StyledBadgeLG>
      );
    }
    if (iconSize === "xs") {
      return (
        <StyledBadgeXS
          badgeContent={renderContent()}
          color="error"
          invisible={renderBadge()}
        >
          <ACIcon
            iconname={renderIcon()}
            style={{
              color: "#162F4B",
              fontSize: sizeSelector(),
              marginRight: "2.5px",
              marginTop: -2,
            }}
          />
        </StyledBadgeXS>
      );
    }
    return (
      <StyledBadge
        badgeContent={renderContent()}
        color="error"
        invisible={renderBadge()}
      >
        <ACIcon
          iconname={renderIcon()}
          style={{
            color: "#162F4B",
            fontSize: sizeSelector(),
            marginRight: "3.5px",
          }}
        />
      </StyledBadge>
    );
  }

  return (
    <div className={classes.mainConatiner}>
      <div className={classes.shrinkControlContainer}>
        <button
          className={classes.button}
          onClick={(event) => {
            onClick();
            event.stopPropagation();
          }}
          id="commentsButton"
          type="button"
          disabled={disabled}
        >
          {renderBadgeStyle()}

          {renderComments()}
        </button>
      </div>
    </div>
  );
}
